import { motion, useReducedMotion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const Logo = ({ location = 'header', dark = false }) => <a className={`brand ${dark ? 'brand-light' : 'brand-ink'}`} href="/#home" aria-label="Jos Legal Group home" data-testid={`${location}-logo`}>
  <img src={`/assets/logo-${dark ? 'white' : 'ink'}.png`} alt="JOS." width="144" height="59" />
  <span>LEGAL GROUP</span>
</a>;

export const Reveal = ({ children, className = '', delay = 0, ...props }) => {
  const reduced = useReducedMotion();
  return <motion.div className={className} initial={reduced ? false : { opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.12 }} transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }} {...props}>{children}</motion.div>;
};

export const CTA = ({ children = 'Request a consultation', onClick, href, id, className = '' }) => {
  const content = <><span>{children}</span><span className="cta-arrow"><ArrowRight size={18} strokeWidth={1.6} /></span></>;
  return <Button asChild={Boolean(href)} className={`cta ${className}`} onClick={href ? undefined : onClick} data-testid={id}>{href ? <a href={href}>{content}</a> : content}</Button>;
};

export const Chapter = ({ number, children, light = false }) => <p className={`chapter ${light ? 'chapter-light' : ''}`} data-testid={`chapter-${number}`}><span>{children}</span><span className="chapter-line" aria-hidden="true" /></p>;

export const EditorialStar = ({ className = '' }) => <svg className={className} aria-hidden="true" viewBox="0 0 80 80" fill="none"><path d="M40 0v80M0 40h80M11.7 11.7l56.6 56.6M11.7 68.3l56.6-56.6" stroke="currentColor" strokeWidth="2" /></svg>;